<template>
  <div>
    <div class="category-top-bar" ref="optionsTopBar">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" @click="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex" v-if="!isBlocked">
          <!-- Buton salvare stoc inițial (mod adăugare) -->
          <button
            v-if="!isInEdit"
            type="submit"
            :disabled="loading"
            class="btn btn-icon btn-success mar-rt-10 save"
            style="margin-bottom: 0;"
            @click.prevent="saveInitialStock"
            :title="$t('general.save')"
          >
            <img src="/static/img/icons/save.png">
            {{ $t('general.save') }}
          </button>

          <!-- Buton salvare modificări (mod editare) -->
          <button
            v-else
            type="submit"
            :disabled="loading"
            class="btn btn-icon btn-success mar-rt-10 save"
            style="margin-bottom: 0;"
            @click.prevent="updateStock"
            :title="$t('general.saveChanges')"
          >
            <img src="/static/img/icons/save.png">
            Salvează modificările
          </button>
        </p>
      </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
        <div class="modal-header">
          <p>{{ $t('gestiune.addInitialStock') }}</p>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group" v-if="groupedLocations">
                <label>{{ $t('gestiune.locatie') }}</label>
                <select class="form-control" v-model="selectedLocation" v-validate="modelValidate.location" :disabled="loading || isInEdit">
                  <option :value="null" disabled>Selectează locația</option>
                  <optgroup
                    v-for="group in groupedLocations"
                    :key="group.vat"
                    :label="`VAT: ${group.vat}`"
                  >
                    <option
                      v-for="loc in group.locations"
                      :key="loc.id"
                      :value="loc"
                    >
                      {{ loc.name }}
                    </option>
                  </optgroup>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>{{ $t('gestiune.gestiune') }}</label>
                <el-select
                    v-model="selectedGestiune"
                    placeholder="Selectează gestiunea"
                    :disabled="loading || isInEdit"
                    v-validate="modelValidate.gestiune"
                  >
                  <el-option
                    v-for="gestiune in filteredGestiuni"
                    :key="gestiune.id"
                    :label="gestiune.name"
                    :value="gestiune.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <!-- <div class="col-md-3">
              <div class="form-group">
                <label for="inventoryNumber">{{ $t('invoice.seriesNumber') }}</label>
                <el-select v-model="inventoryNumber" :options="inventoryNumberOptions" :disabled="isInEdit" v-validate="modelValidate.serie">
                  <el-option v-for="item in inventoryNumberOptions" :key="item._id" :label="item.label" :value="item._id" />
                </el-select>
              </div>
            </div> -->
            <div class="col-md-3">
              <div class="form-group">
                <label>{{ $t('gestiune.date') }}</label>
                <input type="datetime-local" :disabled="isBlocked || loading || isInEdit" :max="today" v-validate="modelValidate.date" class="form-control" v-model="inventoryDate" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mar-to-15" v-if="productsListStocks.length > 0 || productsList.length > 0">
      <div class="col-md-12">
        <button
          class="btn-toggle"
          :class="{ 'active': showStockSection }"
          @click="toggleSection('stock')"
          v-if="productsListStocks.length > 0"
        >
          <span class="toggle-text">
            Produse cu stoc inițial
          </span>
          <span class="badge-count">{{ productsListStocks.length }}</span>
        </button>

        <button
          class="btn-toggle"
          :class="{ 'active': showProductsSection }"
          @click="toggleSection('products')"
          v-if="productsList.length > 0"
        >
          <span class="toggle-text">
            Produse fără stoc inițial
          </span>
          <span class="badge-count">{{ productsList.length }}</span>
        </button>
      </div>
    </div>

    <div class="card mar-to-15" v-if="productsListStocks.length > 0 && showStockSection">
      <div class="card-content">
        <table class="table">
          <thead>
            <tr>
              <th>{{ $t('invoice.productName') }}</th>
              <th>{{ $t('gestiune.type') }}</th>
              <th>{{ $t('invoice.unitMeasure') }}</th>
              <th>{{ $t('invoice.quantity') }}</th>
              <th>{{ $t('gestiune.pretPerUnitate') }}</th>
            </tr>
          </thead>
          <tbody>
            <!-- ========================================== -->
            <!-- HEADER: Produse cu stoc inițial            -->
            <!-- ========================================== -->
            <tr v-if="productsListStocks.length > 0" class="section-header-stoc">
              <td colspan="5">
                Produse cu stoc inițial — doar vizualizare
              </td>
            </tr>

            <!-- LISTA 1: Produse cu stoc inițial (read-only) -->
            <template v-for="(item, index) in productsListStocks">
              <template v-if="item.is_hiden !== 1">
                <tr :key="'stock-' + index" class="row-stoc">
                  <td>
                    <span class="badge-stoc">Stoc</span>
                    {{ item.name }}

                    <div style="font-size: 11px; opacity: 0.7; margin-top:10px;">
                      ID: {{ item._id }}
                    </div>
                  </td>
                  <td>{{ item.categorie }}</td>
                  <td>{{ item.um }}</td>
                  <td>
                    <input
                      type="number"
                      class="form-control"
                      v-model.number="item.quantity"
                      min="0"
                      placeholder="Cantitate"
                      disabled
                      title="Stoc inițial deja setat"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      class="form-control"
                      v-model.number="item.price"
                      min="0"
                      placeholder="Preț per unitate"
                      disabled
                      title="Preț inițial deja setat"
                    />
                  </td>
                </tr>
              </template>
            </template>
            <tr v-if="loading"><td>
              <div class="loadingTableCenter">
                <div :class="(loading ? 'show-loader' : 'hide-loader')">
                  <div class="el-loading-spinner">
                    <svg viewBox="25 25 50 50" class="circular">
                      <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                    </svg>
                  </div>
                </div>
              </div>
            </td>
           </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card mar-to-15" v-if="showProductsSection">
      <div class="card-content">
        <div class="row">
          <div class="col-md-4">
            <label>Filtreaza produsele dupa categorie:</label>
            <select v-model="selectedCategory" @change="filterProducts" class="form-control">
              <option :value="null">-- Toate categoriile --</option>
              <option v-for="cat in categories" :key="cat" :value="cat">
                {{ cat }}
              </option>
            </select>
          </div>
        </div>
        <br>
        <table class="table">
          <thead>
            <tr>
              <th>{{ $t('invoice.productName') }}</th>
              <th>{{ $t('gestiune.type') }}</th>
              <th>{{ $t('invoice.unitMeasure') }}</th>
              <th>{{ $t('invoice.quantity') }}</th>
              <th>{{ $t('gestiune.pretPerUnitate') }}</th>
              <th>{{ $t('general.actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!isBlocked">
              <td>
                <v-select
                  v-model="searchProdName"
                  :options="searchProducts"
                  label="label"
                  placeholder="Caută un produs..."
                  :filterable="true"
                  @input="onProductSelect"
                ></v-select>
              </td>
              <td>
                <input type="text" class="form-control" :disabled="true" v-model.number="newItem.categorie" placeholder="UM" />
              </td>
              <td>
                <input type="text" class="form-control" :disabled="true" v-model.number="newItem.unitMeasure" placeholder="UM" />
              </td>
              <td>
                <input type="number" class="form-control" v-model.number="newItem.quantity" placeholder="Cantitate" />
              </td>
              <td>
                <input type="number" class="form-control" v-model.number="newItem.price" placeholder="Preț per unitate" />
              </td>
              <td>
                <button class="btn btn-primary" @click="addItem">{{ $t('general.add') }}</button>
              </td>
            </tr>

            <!-- ========================================== -->
            <!-- HEADER: Produse fără stoc                  -->
            <!-- ========================================== -->
            <tr v-if="productsList.length > 0" class="section-header-produs">
              <td colspan="5">
                Produse fără stoc inițial — completează cantitatea și prețul
              </td>
            </tr>

            <!-- LISTA 2: Produse fără stoc (editable) -->
            <template v-for="(item, index) in productsList">
              <template v-if="item.is_hiden !== 1">
                <tr
                  :key="'prod-' + index"
                  :class="['row-produs', { 'row-exista-stoc': isProductInStock(item._id) }]"
                >
                  <td>
                    <span v-if="isProductInStock(item._id)" class="badge-exista-stoc">Deja în stoc</span>
                    {{ item.name }}
                  </td>
                  <td>{{ item.categorie }}</td>
                  <td>{{ item.um }}</td>
                  <td>
                    <input
                      type="number"
                      class="form-control"
                      v-model.number="item.quantity"
                      min="0"
                      @input="item.quantity = clamp($event.target.value, 0, 999999)"
                      placeholder="Cantitate"
                      :disabled="isProductInStock(item._id)"
                      :title="isProductInStock(item._id) ? 'Produsul există deja în stocul inițial' : ''"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      class="form-control"
                      v-model.number="item.price"
                      min="0"
                      @input="item.price = clamp($event.target.value, 0, 999999)"
                      placeholder="Preț per unitate"
                      :disabled="isProductInStock(item._id)"
                      :title="isProductInStock(item._id) ? 'Produsul există deja în stocul inițial' : ''"
                    />
                  </td>
                </tr>
              </template>
            </template>
            <tr v-if="loading"><td>
              <div class="loadingTableCenter">
                <div :class="(loading ? 'show-loader' : 'hide-loader')">
                  <div class="el-loading-spinner">
                    <svg viewBox="25 25 50 50" class="circular">
                      <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                    </svg>
                  </div>
                </div>
              </div>
            </td>
           </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
        <h5>Comisia de Inventariere</h5>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="presedinteleComisiei">Președintele Comisiei</label>
              <input type="text" id="presedinteleComisiei" v-model="extraFields.presedinte" :disabled="isBlocked" class="form-control" placeholder="Numele președintelui comisiei" />
            </div>
            <div class="form-group">
              <label for="gestionar">Gestionar</label>
              <input type="text" id="gestionar" v-model="extraFields.gestionar" :disabled="isBlocked" class="form-control" placeholder="Numele gestionarului" />
            </div>
            <div class="form-group">
              <label for="notaInternaComisie">Notă internă</label>
              <textarea id="notaInternaComisie" v-model="extraFields.nota" :disabled="isBlocked" class="form-control" placeholder="Informații suplimentare"></textarea>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="comisiaDeInventariere">Comisia de Inventariere</label>
              <input type="text" id="comisiaDeInventariere" v-model="extraFields.comisia" :disabled="isBlocked" class="form-control" placeholder="Denumirea comisiei" />
            </div>
            <div class="form-group">
              <label for="contabilitate">Contabilitate</label>
              <input type="text" id="contabilitate" v-model="extraFields.contabilitate" :disabled="isBlocked" class="form-control" placeholder="Detalii contabilitate" />
            </div>
            <div class="form-group">
              <label for="notaInternaCompletare">Notă internă (completare)</label>
              <textarea id="notaInternaCompletare" v-model="extraFields.nota_completare" :disabled="isBlocked" class="form-control" placeholder="Detalii suplimentare notă internă"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
// import {mapFields} from 'vee-validate'
import swal from 'sweetalert2'
export default {
   // components: {
  //   GeneralTopBar
  // },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      loadingTimeout: null,
      showStockSection: true,
      showProductsSection: false,
      gestiune: '',
      inventoryNumber: '',
      inventoryDate: this.getLocalDateTimeString(),
      selectedLocation: null,
      selectedGestiune: null,
      gestiuneId: null,
      searchProdName: null,
      extraFields: {
        'presedinte': '',
        'comisia': '',
        'gestionar': '',
        'contabilitate': '',
        'nota': '',
        'nota_completare': ''
      },
      newItem: {
        name: '',
        quantity: '',
        unitMeasure: '',
        price: null
      },
      modelValidate: {
        location: 'required',
        gestiune: 'required',
        date: 'required'
      },
      categories: [
        'Marfa',
        'Materii prime',
        'Materiale consumabile',
        'Semifabricate (Reteta)',
        'Produs finit (Reteta)',
        'Produs rezidual',
        'Ambalaje',
        'Obiecte de inventar'
      ],
      selectedCategory: null,
      isInEdit: false,
      isBlocked: false,
      locations: [],
      gestiuneOptions: [],
      productsList: [],
      productsListStocks: [],
      gestiuniList: [],
      inventoryNumberOptions: [],
      searchProducts: []
    }
  },
  created () {
    this.companyID = this.$session.get('selectedCompany')

    let id = this.route && this.route.params && this.route.params.id

    ;(async () => {
      await this.fetchLocation()
      await this.fetchGestiuni()
      if (id) {
        this.isInEdit = true
        this.getInitialStock(id)
      } else {
        this.showStockSection = false
        this.showProductsSection = true
      }
    })()
  },
  watch: {
    selectedLocation () {
      // dacă suntem în edit, nu modificăm gestiunea
      if (!this.isInEdit) {
        this.selectedGestiune = null

        if (this.filteredGestiuni && this.filteredGestiuni.length) {
          this.selectedGestiune = this.filteredGestiuni[0].id

          console.log('this.selectedGestiune', this.selectedGestiune)
        }
      }

      if (!this.isInEdit) {
        this.productsList = []
      }
    },
    selectedGestiune () {
      if (!this.isInEdit) {
        this.fetchProducts()
      }
    }
  },
  computed: {
    today () {
      const now = new Date()
      now.setSeconds(0, 0)
      return now.toISOString().slice(0, 16)
    },
    groupedLocations () {
      const groups = {}

      this.locations.forEach(location => {
        const vat = location.inv_fiscal_code || 'Fără cod fiscal'
        if (!groups[vat]) {
          groups[vat] = []
        }
        groups[vat].push(location)
      })

      const result = Object.entries(groups).map(([vat, locations]) => ({
        vat,
        locations
      }))

      // console.log('groupedLocations result:', result)  // afisează rezultatul final

      console.log('result', result)

      return result
    },
    filteredGestiuni () {
      if (!this.selectedLocation) return []
      const result = this.gestiuneOptions.filter(
        (g) => g.externalLocationId === this.selectedLocation.true_id
      )
      return result
    }
  },
  methods: {
    filterProducts () {
      this.productsList.forEach(p => {
        if (!this.selectedCategory || p.categorie === this.selectedCategory) {
          p.is_hiden = 0
        } else {
          p.is_hiden = 1
        }
      })
    },
    clamp (value, min, max) {
      if (value === '' || value === null || value === undefined) return ''

      const v = Number(value)
      if (isNaN(v)) return ''

      return Math.min(Math.max(v, min), max)
    },
    toggleSection (section) {
      if (section === 'stock') {
        this.showStockSection = true
        this.showProductsSection = false
      }

      if (section === 'products') {
        this.showProductsSection = true
        this.showStockSection = false
      }
    },
    async waitForGroupedLocations () {
      return new Promise(resolve => {
        if (this.groupedLocations.length) {
          return resolve()
        }

        const unwatch = this.$watch(
          'groupedLocations',
          (val) => {
            if (val.length) {
              unwatch()
              resolve()
            }
          },
          { immediate: true }
        )
      })
    },
    onProductSelect (selected) {
      if (selected) {
        this.newItem = {
          id: selected._id,
          name: selected.name,
          quantity: null,
          unitMeasure: selected.um || '',
          price: null
        }
      }
    },
    goBack () {
      this.$bus.$emit('refresh')
      this.$bus.$emit('close-modal')
    },
    addItem () {
      if (this.newItem && this.newItem.name && this.newItem.quantity != null) {
        const index = this.productsList.findIndex(
          p => p._id === this.newItem.id
        )
        if (index !== -1) {
          this.productsList[index].quantity = this.newItem.quantity
          this.productsList[index].price = this.newItem.price
        } else {
          // this.$message.error('Produsul nu a fost găsit în listă.')
        }
        this.resetNewItem()
      } else {
        // this.$message.error('Toate câmpurile sunt necesare.')
      }
      return false
    },
    removeItem (index) {
      // this.items.splice(index, 1)
    },
    isProductInStock (productId) {
      return this.productsListStocks.some(stock => stock._id === productId)
    },
    resetNewItem () {
      this.searchProdName = null
      this.newItem = {
        productName: '',
        code: '',
        unitMeasure: '',
        quantity: null,
        price: null
      }
    },
    async fetchLocation () {
      const dataToSend = {
        company_id: this.companyID,
        token: this.$session.get('token')
      }

      this.apiRequest('/gestiune/locations', 'GET', dataToSend, (response) => {
        if (!response || response.status !== true || !response.data || !response.data.locations) {
          swal({
            title: 'Eroare!',
            text: response.message || 'Eroare la preluarea locațiilor.',
            type: 'error',
            timer: 3000,
            showConfirmButton: false
          })
          return
        }

        this.locations = response.data.locations
      })
    },
    async fetchGestiuni () {
      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${this.companyID}`)
        if (!response.ok) throw new Error('Failed to fetch gestiuni')

        const data = await response.json()
        if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
          this.gestiuneOptions = data.gestiuni.map((gest) => ({
            id: gest._id,
            name: `${gest.name} (${gest.cod_gestiune})`,
            externalLocationId: gest.externalLocationId || ''
          }))
        } else {
          this.$message.error('Nu s-a primit un array valid de la server.')
        }
      } catch (error) {
        this.$message.error(`Request failed: ${error.message}`)
        console.error('Error fetching management data:', error)
      }
    },
    async fetchProducts (page = 1, pageSize = 2000) {
      this.productsList = []
      if (!this.selectedLocation) return

      clearTimeout(this.loadingTimeout)
      this.loadingTimeout = setTimeout(() => { this.loading = true }, 10)

      try {
        // URL cu paginare
        let url = `${process.env.API_BASE_URL_GESTIUNE}:4443/products?externalCompanyId=${this.companyID}`

        if (this.selectedLocation.inv_fiscal_code) {
          url += `&vatNumber=${this.selectedLocation.inv_fiscal_code}`
        }

        if (this.inventoryDate) {
          url += `&inventoryDate=${this.inventoryDate}`
        }

        console.log('this.selectedGestiune', this.selectedGestiune)

        if (this.gestiuneId) {
          url += `&gestiune=${this.gestiuneId}`
        }

        url += `&isStockInitial=true`
        url += `&page=${page}&limit=${pageSize}`

        const response = await fetch(url)
        const data = await response.json()

        if (Array.isArray(data.products)) {
          // adaug câmpul quantity pentru input
          this.productsList = data.products.map(prod => ({
            ...prod,
            quantity: null,
            price: null
          }))

          this.searchProducts = (data.products || [])
          .filter(p => p && p.name)
          .map(prod => ({
            ...prod,
            label: prod.name || ''
          }))

          console.log('this.productsList', this.productsList)
        } else {
          this.$message.error('Eroare la încărcarea produselor.')
        }

        clearTimeout(this.loadingTimeout)
        this.loading = false
      } catch (error) {
        this.$message.error(`Eroare: ${error.message}`)
        clearTimeout(this.loadingTimeout)
        this.loading = false
      }
    },
    formatLocalDateTime (dateStr) {
      if (!dateStr) return ''

      const d = new Date(dateStr)

      const pad = (n) => String(n).padStart(2, '0')

      return (
        d.getFullYear() +
        '-' + pad(d.getMonth() + 1) +
        '-' + pad(d.getDate()) +
        'T' + pad(d.getHours()) +
        ':' + pad(d.getMinutes())
      )
    },
    async getInitialStock (id) {
      if (!id) return

      try {
        this.loading = true

        await this.waitForGroupedLocations()

        const url = new URL(`${process.env.API_BASE_URL_GESTIUNE}:4443/stoc-initial/get`)
        url.searchParams.append('id', id)
        url.searchParams.append('externalCompanyId', this.companyID)

        const response = await fetch(url)
        const result = await response.json()

        if (!response.ok) {
          swal({ icon: 'error', title: 'Eroare!', text: result.error || 'Nu s-a putut încărca stocul inițial' })
          return
        }

        console.log('result.externalLocationId', result.externalLocationId)
        console.log('this.groupedLocations', this.groupedLocations)

        // Completează locația
        if (result.externalLocationId) {
          this.selectedLocation = this.groupedLocations
            .flatMap(g => g.locations)
            .find(l => l.true_id === result.externalLocationId) || null
        }

        console.log('this.selectedLocation', this.selectedLocation)

        // Completează gestiunea
        this.selectedGestiune = result.gestiune_id || null
        this.gestiuneId = result.gestiune_id || null

        if (Array.isArray(result.extraFields)) {
          this.extraFields = result.extraFields.reduce((acc, { key, value }) => {
            acc[key] = value
            return acc
          }, {})
        } else {
          this.extraFields = {}
        }

        // Completează data
        this.inventoryDate = result.date
          ? this.formatLocalDateTime(result.date)
          : null

        // Completează produsele
        this.productsListStocks = result.lines.map(line => ({
          _id: line.product_id,
          name: line.product.name || '',
          categorie: line.product.categorie || '',
          quantity: line.quantity,
          price: line.price || 0,
          um: line.product.um || '', // dacă ai unitate de măsură
          is_hiden: 0
        }))

        this.fetchProducts()
      } catch (error) {
        swal({ icon: 'error', title: 'Eroare!', text: error.message })
      } finally {
        this.loading = false
      }
    },
    async updateStock () {
      if (!this.selectedGestiune || !this.inventoryDate) {
        swal({ icon: 'warning', title: 'Alege gestiunea și data documentului!' })
        return
      }

      // Filtrează doar produsele NOI (din productsList, nu din productsListStocks)
      const productsToSend = this.productsList.filter(p => p.quantity > 0)

      if (!productsToSend.length) {
        swal({ icon: 'warning', title: 'Adaugă cel puțin un produs cu cantitate mai mare ca 0!' })
        return
      }

      // Verifică produsele fără preț
      const missingPrices = productsToSend
        .filter(p => p.price === null || p.price === undefined || p.price === 0)
        .map(p => p.name)

      if (missingPrices.length > 0) {
        swal({
          icon: 'error',
          title: 'Eroare! Produse fără preț',
          html: `
            <p style="margin-bottom:10px;">Următoarele produse nu au preț setat:</p>
            <ul style="text-align:left; padding-left:20px; color:#d32f2f; font-weight:600;">
              ${missingPrices.map(name => `<li>${name}</li>`).join('')}
            </ul>
            <p style="margin-top:10px; font-size:14px; color:#555;">
              Te rugăm să completezi prețul înainte de a salva modificările.
            </p>
          `,
          showCloseButton: true,
          confirmButtonText: 'OK'
        })
        return
      }

      const confirmed = await this.confirmUmAndPriceWarning()
      if (!confirmed) return

      const extraFieldsArray = Object.entries(this.extraFields).map(([key, value]) => ({
        key,
        value
      }))

      try {
        const body = {
          externalCompanyId: this.companyID,
          gestiune: this.selectedGestiune,
          date: this.inventoryDate,
          lines: productsToSend.map(p => ({
            product_id: p._id,
            quantity: p.quantity,
            price: p.price
          })),
          extraFields: extraFieldsArray
        }

        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/stoc-initial-update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        })

        const result = await response.json()

        if (!response.ok) {
          swal({ icon: 'error', title: 'Eroare!', text: result.error || 'Eroare la actualizarea stocului inițial' })
          return
        }

        swal({
          title: 'Success',
          text: 'Stoc inițial actualizat cu succes.',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        })

        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')

        // Golește doar lista de produse noi, păstrează stocurile existente
        this.productsList = []
      } catch (error) {
        swal({ icon: 'error', title: 'Eroare!', text: error.message })
      }
    },
    confirmUmAndPriceWarning () {
      return swal({
        icon: 'warning',
        title: 'Atenție!',
        text: 'Vă rog să vă asigurați că unitățile de măsură selectate sunt corecte și că prețul este corespunzător unității de măsură selectate. În cazul în care sunt corecte, continuați apăsând butonul „Salvează”.',
        showCancelButton: true,
        confirmButtonText: 'Salvează',
        cancelButtonText: 'Anulează'
      }).then(result => !!result).catch(() => false)
    },
    async saveInitialStock () {
      if (!this.selectedGestiune || !this.inventoryDate) {
        swal({ icon: 'warning', title: 'Alege gestiunea și data documentului!' })
        return
      }

      // Filtrează produsele cu cantitate > 0
      const productsToSend = this.productsList.filter(p => p.quantity > 0)

      if (!productsToSend.length) {
        swal({ icon: 'warning', title: 'Adaugă cel puțin un produs cu cantitate mai mare ca 0!' })
        return
      }

      // Verifică produsele fără preț
      const missingPrices = productsToSend
        .filter(p => p.price === null || p.price === undefined || p.price === 0)
        .map(p => p.name)

      if (missingPrices.length > 0) {
        swal({
          icon: 'error',
          title: 'Eroare! Produse fără preț',
          html: `
            <p style="margin-bottom:10px;">Următoarele produse nu au preț setat:</p>
            <ul style="text-align:left; padding-left:20px; color:#d32f2f; font-weight:600;">
              ${missingPrices.map(name => `<li>${name}</li>`).join('')}
            </ul>
            <p style="margin-top:10px; font-size:14px; color:#555;">
              Te rugăm să completezi prețul înainte de a salva stocul inițial.
            </p>
          `,
          showCloseButton: true,
          confirmButtonText: 'OK'
        })
        return
      }

      const confirmed = await this.confirmUmAndPriceWarning()
      if (!confirmed) return

      const extraFieldsArray = Object.entries(this.extraFields).map(([key, value]) => ({
        key,
        value
      }))

      try {
        const body = {
          externalCompanyId: this.companyID,
          externalLocationId: this.selectedLocation.true_id,
          gestiune: this.selectedGestiune,
          date: this.inventoryDate,
          lines: productsToSend.map(p => ({
            product_id: p._id,
            quantity: p.quantity,
            price: p.price
          })),
          extraFields: extraFieldsArray
        }

        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/stoc-initial`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        })

        const result = await response.json()

        if (!response.ok) {
          swal({ icon: 'error', title: 'Eroare!', text: result.error || 'Eroare la salvarea stocului inițial' })
          return
        }

        swal({
          title: 'Success',
          text: 'Initial stock saved successfully.',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        })

        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')

        // după succes, golește lista de produse
        this.productsList = []
        this.productsListStocks = []
      } catch (error) {
        swal({ icon: 'error', title: 'Eroare!', text: error.message })
      }
    }
  }
}
</script>

<style scoped>
.loadingTableCenter {
  height: 100px;
}
/* ========================================== */
/* HEADER-uri sectiuni                        */
/* ========================================== */

tr.section-header-stoc {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

tr.section-header-stoc td {
  padding: 12px;
  color: #fff;
  font-weight: 600;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  border: none;
  font-size: 15px;
}

tr.section-header-produs {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

tr.section-header-produs td {
  padding: 12px;
  color: #fff;
  font-weight: 600;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  border: none;
  font-size: 15px;
}

tr.row-exista-stoc {
  background-color: #fff3e0 !important; /* portocaliu foarte deschis */
  opacity: 0.85;
  display: none;
}

tr.row-exista-stoc:hover {
  background-color: #ffe0b2 !important;
}

tr.row-exista-stoc td {
  color: #e65100;
}
.btn-toggle {
  font-size: 16px;
  font-weight: 400;
  text-transform: uppercase;
  color: #7c8db5;
  background-color: #fff;
  border: none;
  opacity: 1;
  margin: 0 10px;
  padding: 10px 0;
  border-radius: 0;
  padding-bottom: 0;
}

.btn-toggle.active {
  background-color: #fff;
  color: #674BD2;
  border-bottom: 1px solid #674BD2;
}

.btn-toggle.active .badge-count {
  background: #674BD2;
  color: #fff;
}

.toggle-icon {
  font-size: 1.2rem;
}

.toggle-text {
  white-space: nowrap;
  font-size: 14px;
}

.badge-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  background: #674BD2;
  color: #fff;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 700;
  transition: all 0.3s ease;
  margin-bottom: 5px;
}
/* Badge "Deja în stoc" */
.badge-exista-stoc {
  display: inline-block;
  padding: 2px 8px;
  font-size: 0.65rem;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
  border-radius: 20px;
  margin-right: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 10px;
}

tr.row-exista-stoc input:disabled {
  background-color: #ffe0b2;
  border: 1px dashed #ff9800;
  color: #e65100;
  cursor: not-allowed;
}

/* ========================================== */
/* Rânduri stoc (read-only)                   */
/* ========================================== */

tr.row-stoc {
  background-color: #f8f9fa;
  transition: all 0.2s ease;
}

tr.row-stoc:hover {
  background-color: #e9ecef;
}

tr.row-stoc td {
  color: #25396F;
  vertical-align: middle;
}

/* Badge STOC */
.badge-stoc {
  display: inline-block;
  padding: 3px 10px;
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  margin-right: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Input-uri disabled */
tr.row-stoc input:disabled {
  background-color: #e9ecef;
  border: 1px dashed #ced4da;
  color: #25396F;
  cursor: not-allowed;
  font-weight: 500;
}

tr.row-stoc input:disabled::placeholder {
  color: transparent;
}

/* ========================================== */
/* Rânduri produs (editable)                  */
/* ========================================== */

tr.row-produs {
  background-color: #fff;
  transition: all 0.2s ease;
}

tr.row-produs:hover {
  background-color: #f8f9fa;
}

tr.row-produs td {
  vertical-align: middle;
}

tr.row-produs input {
  border: 2px solid #e9ecef;
  border-radius: 8px;
  transition: all 0.2s ease;
}

tr.row-produs input:focus {
  border-color: #f5576c;
  box-shadow: 0 0 0 3px rgba(245, 87, 108, 0.15);
  outline: none;
}

/* ========================================== */
/* Separator între secțiuni                   */
/* ========================================== */

tr.section-divider td {
  height: 4px;
  padding: 0;
  background: linear-gradient(90deg, #667eea 0%, #f5576c 100%);
  border: none;
}
.v-select input[type=search], .v-select input[type=search]:focus,
.v-select.searchable .dropdown-toggle {
    min-height: 46px;
    height: 46px;
}
.btn-primary {
  padding: 5px 50px;
}
.button-group {
    display: flex; /* Folosește flexbox pentru alinierea orizontală */
    justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.el-select,
.el-input {
  width: 100%;
}
label {
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/InitialStock/ManagementInitialStockForm.vue